import { styled } from 'styled-components';
import { rgba } from 'polished';
import { motion } from 'framer-motion';

interface IProps {
    $show?: boolean;
    size?: 'small';
}

export const ListItemMediaIcon = styled(motion.div).attrs<{ $show?: boolean }>(
    ({ $show }: IProps) =>
        // Animation properties
        ({
            transition: {
                type: 'easeOut',
            },
            variants: {
                initListItemButton: {
                    scale: 0.8,
                    opacity: $show ? 1 : 0,
                },
                hoverListItemButton: {
                    opacity: 1,
                    scale: 1,
                    transition: { type: 'easeIn' },
                },
            },
        })
)<IProps>`
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => rgba(theme.palette.common.black, 0.62)};
    border-radius: 50%;
    font-size: ${({ theme }) => theme.typography.pxToRem(30)};

    svg {
        width: 2.3rem;
        height: 2.3rem;
    }

    ${({ theme }) => theme.breakpoints.up('sm')} {
        transform: scale(1);

        ${({ size }) => {
            if (!size) {
                return `
                    width: 60px;
                    height: 60px;
                `;
            }

            return (
                size === 'small' &&
                `
                    height: 50px;
                    width: 50px;
                `
            );
        }}

        svg {
            width: 3rem;
            height: 3rem;
        }
    }
`;
